import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ActionButton from './action-button';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import Menu from 'fuse-ui/components/Menu';
import MenuItem from 'fuse-ui/components/MenuItem';

import { translate } from '../../../utils/translation-utils';

const domainTypeOptions = [
    { display: translate( 'sending-domains' ), key: 'sending' },
    { display: translate( 'nonsending-domains' ), key: 'nonsending' }
];

export class DropdownActionButton extends Component{
    constructor( props ){
        super( props );

        this.anchorEl = React.createRef();
        this.state = {
            open: false,
        };
    }

    changeSelection = ( selectedOption ) => {
        this.props.handleSelectionChange( selectedOption );
        this.setOpen( false );
    }

    handlePopoverToggle = () => {
        this.setOpen( !this.state.open );
    }

    handlePopoverClose = ( event ) => {
        if( this.anchorEl.current.contains( event.target ) ){
            return;
        }
        this.setOpen( false );
    }

    setOpen = ( open ) => this.setState( { open } )

    render(){
        const { automationId, text, type } = this.props;
        const { open } = this.state;

        const optionMap = {
            domainType: domainTypeOptions
        };

        return (
            <>
                <ActionButton
                    buttonRef={this.anchorEl}
                    dataId={automationId}
                    onClick={this.handlePopoverToggle}
                >
                    {text}
                    <ArrowDropDown />
                </ActionButton>
                <Menu
                    anchorEl={this.anchorEl.current}
                    onClose={this.handlePopoverClose}
                    open={open}
                >
                    {
                        optionMap[type].map( ( option ) => {
                            return (
                                <MenuItem
                                    key={option.key}
                                    onClick={() => this.changeSelection( option.key )}
                                >
                                    {option.display}
                                </MenuItem>
                            );
                        } )
                    }
                </Menu>
            </>
        );
    }
};

DropdownActionButton.propTypes = {
    automationId: PropTypes.string.isRequired,
    handleSelectionChange: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
};

export default DropdownActionButton;
